/**
 * @generated SignedSource<<e3d7bf1c93bea8396b0d2d6031130fb3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShareClipModalRemoveMutation$variables = {
  channelId: string;
  noteId?: string | null;
  recordingOrClipId?: string | null;
};
export type ShareClipModalRemoveMutation$data = {
  readonly removeFromChannel: {
    readonly channel: {
      readonly " $fragmentSpreads": FragmentRefs<"ShareMeetingModal_Channel">;
    };
    readonly note: {
      readonly " $fragmentSpreads": FragmentRefs<"ShareMeetingModal_postedChannels">;
    } | null;
    readonly recordingOrClip: {
      readonly " $fragmentSpreads": FragmentRefs<"ShareClipModal_postedChannels">;
    } | null;
  } | null;
};
export type ShareClipModalRemoveMutation = {
  response: ShareClipModalRemoveMutation$data;
  variables: ShareClipModalRemoveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "channelId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recordingOrClipId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "channelId",
    "variableName": "channelId"
  },
  {
    "kind": "Variable",
    "name": "noteId",
    "variableName": "noteId"
  },
  {
    "kind": "Variable",
    "name": "recordingOrClipId",
    "variableName": "recordingOrClipId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Channel",
  "kind": "LinkedField",
  "name": "postedInChannels",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "members",
      "plural": true,
      "selections": [
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewCount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userVideoProgress",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFavourite",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingRecordedVideoPosterUrl",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingRecordedVideoDuration",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingRecordedVideoUrl",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTopUser",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "ownerAccount",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventStart",
  "storageKey": null
},
v23 = [
  (v5/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "meetingVideoAndTranscriptionDownloadUrl",
    "storageKey": null
  },
  (v16/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "meetingCallStart",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasSummary",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "RecordingAttendee",
    "kind": "LinkedField",
    "name": "attendees",
    "plural": true,
    "selections": [
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "viewerCanDelete",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "note",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v5/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v22/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecordingLink",
            "kind": "LinkedField",
            "name": "meetingRecordingLink",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "type": "Note",
        "abstractKey": null
      }
    ],
    "storageKey": null
  },
  (v21/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareClipModalRemoveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "RemoveFromChannel",
        "kind": "LinkedField",
        "name": "removeFromChannel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "recordingOrClip",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ShareClipModal_postedChannels"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ShareMeetingModal_postedChannels"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Channel",
            "kind": "LinkedField",
            "name": "channel",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ShareMeetingModal_Channel"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ShareClipModalRemoveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "RemoveFromChannel",
        "kind": "LinkedField",
        "name": "removeFromChannel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "recordingOrClip",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isMeetingRecordingInterface"
              },
              (v8/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Channel",
            "kind": "LinkedField",
            "name": "channel",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postsCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isMember",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPersonal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isWorkspaceWide",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isMyMeetings",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isFavorites",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 4
                  }
                ],
                "concreteType": "ChannelPostConnection",
                "kind": "LinkedField",
                "name": "posts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChannelPostEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isChannelPostInterface"
                          },
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MeetingRecordingClip",
                            "kind": "LinkedField",
                            "name": "clip",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanEdit",
                                "storageKey": null
                              },
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "createdAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "type",
                                    "storageKey": null
                                  },
                                  (v17/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "firstName",
                                    "storageKey": null
                                  },
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isActive",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isConfigured",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isGuest",
                                    "storageKey": null
                                  },
                                  (v20/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isExternal",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v21/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MeetingRecording",
                            "kind": "LinkedField",
                            "name": "recording",
                            "plural": false,
                            "selections": (v23/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Note",
                            "kind": "LinkedField",
                            "name": "note",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rawDraftJson",
                                "storageKey": null
                              },
                              (v22/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NoteUser",
                                "kind": "LinkedField",
                                "name": "noteuserSet",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v17/*: any*/),
                                      (v19/*: any*/),
                                      (v18/*: any*/),
                                      (v20/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MeetingRecording",
                                "kind": "LinkedField",
                                "name": "longestMeetingRecording",
                                "plural": false,
                                "selections": (v23/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "posts(first:4)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b66091f5dd1ac0f7d876c92b1c6ffe2a",
    "id": null,
    "metadata": {},
    "name": "ShareClipModalRemoveMutation",
    "operationKind": "mutation",
    "text": "mutation ShareClipModalRemoveMutation(\n  $recordingOrClipId: ID\n  $noteId: ID\n  $channelId: ID!\n) {\n  removeFromChannel(recordingOrClipId: $recordingOrClipId, noteId: $noteId, channelId: $channelId) {\n    recordingOrClip {\n      __typename\n      ...ShareClipModal_postedChannels\n      id\n    }\n    note {\n      ...ShareMeetingModal_postedChannels\n      id\n    }\n    channel {\n      ...ShareMeetingModal_Channel\n      id\n    }\n  }\n}\n\nfragment ClipsPanel_DeleteClipModal_clip on MeetingRecordingClip {\n  id\n  title\n}\n\nfragment ClipsPanel_RenameClipModal_clip on MeetingRecordingClip {\n  id\n  title\n}\n\nfragment ShareClipModal_postedChannels on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  postedInChannels {\n    id\n    name\n    isPrivate\n    members {\n      id\n    }\n  }\n}\n\nfragment ShareMeetingModal_Channel on Channel {\n  id\n  name\n  postsCount\n  isMember\n  isPrivate\n  isPersonal\n  isWorkspaceWide\n  isMyMeetings\n  isFavorites\n  posts(first: 4) {\n    edges {\n      node {\n        __typename\n        __isChannelPostInterface: __typename\n        id\n        clip {\n          ...ClipsPanel_RenameClipModal_clip\n          ...ClipsPanel_DeleteClipModal_clip\n          id\n          viewCount\n          userVideoProgress\n          isFavourite\n          visibility\n          viewerCanEdit\n          meetingRecordedVideoPosterUrl\n          meetingRecordedVideoDuration\n          meetingRecordedVideoUrl\n          title\n          createdAt\n          creator {\n            id\n            type\n            email\n            firstName\n            fullName\n            image\n            isActive\n            isConfigured\n            isGuest\n            isTopUser\n            isExternal\n          }\n          ownerAccount {\n            __typename\n            id\n            name\n          }\n        }\n        recording {\n          id\n          title\n          viewCount\n          userVideoProgress\n          isFavourite\n          meetingRecordedVideoPosterUrl\n          meetingRecordedVideoDuration\n          meetingVideoAndTranscriptionDownloadUrl\n          meetingRecordedVideoUrl\n          meetingCallStart\n          hasSummary\n          attendees {\n            email\n            fullName\n            image\n            isTopUser\n          }\n          viewerCanDelete\n          note {\n            __typename\n            ... on Note {\n              id\n              eventStart\n              meetingRecordingLink {\n                id\n                visibility\n              }\n            }\n            id\n          }\n          ownerAccount {\n            __typename\n            id\n            name\n          }\n        }\n        note {\n          id\n          title\n          rawDraftJson\n          eventStart\n          noteuserSet {\n            user {\n              id\n              email\n              image\n              fullName\n              isTopUser\n            }\n            id\n          }\n          longestMeetingRecording {\n            id\n            title\n            viewCount\n            userVideoProgress\n            isFavourite\n            meetingRecordedVideoPosterUrl\n            meetingRecordedVideoDuration\n            meetingVideoAndTranscriptionDownloadUrl\n            meetingRecordedVideoUrl\n            meetingCallStart\n            hasSummary\n            attendees {\n              email\n              fullName\n              image\n              isTopUser\n            }\n            viewerCanDelete\n            note {\n              __typename\n              ... on Note {\n                id\n                eventStart\n                meetingRecordingLink {\n                  id\n                  visibility\n                }\n              }\n              id\n            }\n            ownerAccount {\n              __typename\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ShareMeetingModal_postedChannels on Note {\n  postedInChannels {\n    id\n    name\n    isPrivate\n    members {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b53f5e1164f4664ed4e4a6ea2b86392d";

export default node;
